import React from 'react';
import PropTypes from 'prop-types';

/* Icons */
import { Pencil, Trash } from '../../../../../../assets/images/index';

import {
  StyledStartText,
  StyledCenterWrap,
  StyledEditButton,
  StyledIcon
} from './style';

const TrafficEdit = ({ address, onClickEdit, onClickRemove }) => (
  <StyledCenterWrap>
    <StyledStartText>{address}</StyledStartText>
    <StyledEditButton dark onClick={onClickEdit}>
      <StyledIcon svg={Pencil} size="s" color="light" />
    </StyledEditButton>
    <StyledEditButton dark onClick={onClickRemove}>
      <StyledIcon svg={Trash} size="s" color="light" />
    </StyledEditButton>
  </StyledCenterWrap>
);

TrafficEdit.propTypes = {
  address: PropTypes.string,
  onClickEdit: PropTypes.func,
  onClickRemove: PropTypes.func
};

export default TrafficEdit;
